import { createSlice } from '@reduxjs/toolkit'
import { billsSliceInitialState } from './billsSlice.data'
import { IBillsSliceInitialStateInterface as ibsisi } from './billsSlice.types'
import { RootState } from '../store'

const billsSlice = createSlice({
  name: 'bills',
  initialState: billsSliceInitialState,
  reducers: {
    setBillSelectedEvent(state, { payload }: { payload: ibsisi['selected']['event'] }) {
      state.selected.event = payload
    },
    setSelectedEventFees(state, { payload }: { payload: ibsisi['selected']['eventFees'] }) {
      state.selected.eventFees = payload
    },
    setSelectedRecipient(state, { payload }: { payload: ibsisi['selected']['recipient'] }) {
      state.selected.recipient = payload
    },
  },
})

// Redux selectors
const selectBillRecipient = (state: RootState) => state.bills.selected.recipient

export { selectBillRecipient }

export const { setBillSelectedEvent, setSelectedEventFees, setSelectedRecipient } =
  billsSlice.actions
export default billsSlice.reducer
